import { render, staticRenderFns } from "./productlinefile.vue?vue&type=template&id=57df0197&scoped=true&"
import script from "./productlinefile.vue?vue&type=script&lang=js&"
export * from "./productlinefile.vue?vue&type=script&lang=js&"
import style0 from "./productlinefile.vue?vue&type=style&index=0&id=57df0197&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df0197",
  null
  
)

export default component.exports